import { useRef, useState, useEffect, useContext, createContext } from 'react';
import { debounce } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, Button, MenuItem, Autocomplete, Chip } from '@mui/material';
import axios from "axios";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { API, MSG } from "./constantsFront";
import { MsgContext } from "../../App";
import moment from 'moment';
import { gridColumnPositionsSelector } from '@mui/x-data-grid';
export const RacQuarCountryContext = createContext();


/**
 * 残留農薬検疫新規・編集
 * @returns 
 */

const G02011RacQuarantineEdit = () => {
  const location = useLocation();
  let select_rac_id = '';
  let select_country_code = '';
  let select_country_name = '';
  let select_product_code = '';
  let select_enable_date = '';

  if (location.state != null) {
    select_rac_id = location.state.ID; // 選択したID
    select_country_code = location.state.CountryCode; // 選択した国コード
    select_country_name = location.state.CountryName; // 選択した国名
    select_product_code = location.state.ProductCode; // 選択した品目コード
    select_enable_date = location.state.EnableDate; // 選択した有効日

    // ローカルストレージに保存する
    window.localStorage.setItem("select_rac_id", select_rac_id);
    window.localStorage.setItem("select_country_code", select_country_code);
    window.localStorage.setItem("select_country_name", select_country_name);
    window.localStorage.setItem("select_product_code", select_product_code);
    window.localStorage.setItem("select_enable_date", select_enable_date);
  } else {
    // ローカルストレージから取り出す
    select_rac_id = window.localStorage.getItem("select_rac_id");
    select_country_code = window.localStorage.getItem("select_country_code");
    select_country_name = window.localStorage.getItem("select_country_name");
    select_product_code = window.localStorage.getItem("select_product_code");
    select_enable_date = window.localStorage.getItem("select_enable_date");
  }

  const [ProductCode, setProductCode] = useState(""); // 品目コード
  const [ExCode, setExCode] = useState(""); // 輸出可否（コード）
  const [SpecialCond, setSpecialCond] = useState(""); // 注釈
  const [Url, setUrl] = useState(""); // 関連URL
  const [Supplement, setSupplement] = useState(""); // 補足文言
  const [EnableDate, setEnableDate] = useState(""); // 有効日
  const [DisableDate, setDisableDate] = useState(""); // 無効日

  const [ExportLicenseList, setExportLicenseList] = useState([]); // 輸出可否マスタ取得

  const [racQuarMain, setRacQuarMain] = useState(""); // Edit画面表題
  const { msg, setMsg } = useContext(MsgContext); // エラーメッセージ

  // 選択されている内容
  const [autocompleteCountry, setAutocompleteCountry] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  // 前回のキーワード
  const [beforeCountry, setBeforeCountry] = useState("");

  const [errorCountry, setErrorCountry] = useState(""); // 輸出相手国名エラー
  const [errorProductCode, setErrorProductCode] = useState(""); // 品目コードエラー
  const [errorEnableDate, setErrorEnableDate] = useState(""); // 有効日エラー
  const [errorExCode, setErrorExCode] = useState(""); // 輸出可否エラー

  // ダイアログ用
  const selectValue = {
    autocompleteCountry,
    setAutocompleteCountry,
  };

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);


  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    // 輸出可否マスタ取得
    axios.post("/m_export_license/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }
      setExportLicenseList(res.data.dataList);
    });

    if (select_rac_id == -1) {
      setRacQuarMain("残留農薬検疫　新規登録");
    } else {
      // ここで情報を取得する
      getRacQuar();
      setRacQuarMain("残留農薬検疫　編集");
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, [])

  // 残留農薬検疫情報取得
  async function getRacQuar() {
    try {
      console.log("値取得開始");

      let quarList = [];
      console.log(select_country_code)
      console.log(select_product_code)
      body.CountryCode = select_country_code;
      body.ProductCode = select_product_code;
      body.EnableDate = select_enable_date;

      await axios.post("/m_rac_quar/select/admin/auth", body).then(res => {
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        quarList = res.data.quarList;

        setProductCode(quarList[0].product_code);
        setExCode(quarList[0].exportability_code);
        setSpecialCond(quarList[0].special_cond);
        setUrl(quarList[0].url);
        setSupplement(quarList[0].supplement);
        if (quarList[0].enable_date) {
          setEnableDate(
            moment(quarList[0].enable_date).format("YYYY-MM-DD")
          );
        }
        if (quarList[0].disable_date) {
          setDisableDate(
            moment(quarList[0].disable_date).format("YYYY-MM-DD")
          );
        }
        selectValue.autocompleteCountry.push({ country_code: select_country_code, country_name: select_country_name })

        return console.log("値取得終了");

      });


    } catch (e) {
      console.log("例外が発生しました");
      console.log(e.message);
      setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // 保存処理
  async function register() {
    try {

      let errCnt = 0;

      if (autocompleteCountry.length > 1) {
        setErrorCountry("輸出相手国名は1つのみ選択してください。");
        errCnt++;
      } else if (autocompleteCountry.length == 0) {
        setErrorCountry("輸出相手国名は必須です。");
        errCnt++;
      } else {
        setErrorCountry("");
      }

      if (!ProductCode) {
        setErrorProductCode("品目コードは必須です。");
        errCnt++;
      } else {
        setErrorProductCode("");
      }

      if (!EnableDate) {
        setErrorEnableDate("有効日は必須です。");
        errCnt++;
      } else {
        setErrorEnableDate("");
      }

      if (!ExCode) {
        setErrorExCode("輸出可否は必須です。");
        errCnt++;
      } else {
        setErrorExCode("");
      }

      if (errCnt > 0) {
        return;
      }

      body.CountryCode = autocompleteCountry[0].country_code;
      body.ProductCode = ProductCode.trim();
      body.EnableDate = EnableDate;
      const BeEnableDate = moment(select_enable_date).format("YYYY-MM-DD"); //変更前有効日
      body.BeEnableDate = BeEnableDate;

      if (select_rac_id == -1 || BeEnableDate != EnableDate) {
        // 新規もしくは有効日が変更された場合はここで重複チェックを行う
        const res = await axios.post("/m_rac_quar/select/admin/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        console.log(res);
        if (res.data.quarList.length != 0) {
          if (select_rac_id == -1) {
            setErrorCountry("輸出相手国名は既に登録されています。");
            setErrorProductCode("品目コードは既に登録されています。");
          }
          setErrorEnableDate("有効日は既に登録されています。");
          return;
        }
      }

      body.DisableDate = DisableDate == "" ? null : DisableDate;
      body.ExCode = ExCode;
      body.Supplement = Supplement;
      body.SpecialCond = SpecialCond;
      body.Url = Url;


      console.log(body.CountryCode);
      console.log(body.ProductCode);
      console.log(body.EnableDate);
      console.log(body.DisableDate);
      console.log(body.ExCode);
      console.log(body.Supplement);
      console.log(body.SpecialCond);
      console.log(body.Url);

      // insertとupdateを分岐させる
      if (select_rac_id == -1) {
        body.QuarType = 2;
        const res = await axios.post("/m_synonym_product/select/unregistered/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }

        // 同類が登録されているか
        if (res.data.dataList == 0) {
          const res = await axios.post("/m_synonym_product/max_synonym_id/auth", body);
          // 取得チェック
          if (res.status != 200) {
            return;
          }

          // 同類IDの最大値を取得
          let synonymId = 0;
          if (res.data.dataList.length != 0) {
            synonymId = Number(res.data.dataList[0].synonym_id) + 1;
          }
          body.synonymId = synonymId;
          body.unregistered = true;
        } else {
          body.unregistered = false;
        }

        // insert
        const rac_insert = await axios.post("/m_rac_quar/insert/auth", body);
        if (rac_insert.status === 200) {
          console.log("insert成功");
          const res = await axios.post("/m_rac_quar/enable_change");
          // 有効フラグ処理
          window.location.href = "./G02010RacQuarantineList";
          alert("登録が完了しました。");
        } else {
          console.log("insert失敗");
          setMsg("登録に失敗しました。");
        }
      } else {
        // update
        const rac_update = await axios.post("/m_rac_quar/update/auth", body);
        if (rac_update.status === 200) {
          console.log("update成功");
          const res = await axios.post("/m_rac_quar/enable_change");

          // 有効フラグ処理
          window.location.href = "./G02010RacQuarantineList";
          alert("登録が完了しました。");
        } else {
          console.log("update失敗");
          setMsg("登録に失敗しました。");
        }
      }

    } catch (e) {
      console.log("例外が発生しました");
      console.log(e.message);
      setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // 変更が止まった後、指定時間(ミリ秒)後処理を行う
  const term = 200;
  const countrySearchHandler = debounce(
    (changeValue) => countrySearchMethod(changeValue),
    term
  );

  // サジェスト用処理
  const countrySearchMethod = async (changeValue) => {
    setBeforeCountry(changeValue);
    // 内容が同じ場合は処理しない
    if (changeValue.length > 0 && beforeCountry !== changeValue) {
      body.countryName = changeValue;
      console.log("サジェスト検索 : " + body.countryName);
      try {
        const res = await axios.post("/m_synonym_country/select/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        setCountryOptions([...res.data.dataList]);
        console.log(countryOptions);
      } catch (err) {
        if (err.request.status == 500) {
          setMsg("例外が発生しました。管理者にお問い合わせください。");
          return;
        }
      }
    } else {
      // オートコンプリートの内容初期化
      setCountryOptions([]);
    }
  };

  // 選択データが変わったときの処理
  const countryChange = (event, selectedValue) => {
    // 選択されているオートコンプリート内容変更
    setAutocompleteCountry([...selectedValue]);
    // オートコンプリートの内容初期化
    setCountryOptions([]);
  };

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg">
                <Stack spacing={2}>
                  <h1>{racQuarMain}</h1>

                  <RacQuarCountryContext.Provider value={selectValue}>
                    <Autocomplete
                      id="country"
                      value={autocompleteCountry}
                      disabled={(select_rac_id != -1) ? true : false}
                      // freeSolo // 開閉をなくす
                      multiple
                      options={countryOptions}
                      onInputChange={(e, changeValue) => {
                        countrySearchHandler(changeValue);
                      }} // テキスト内容変更時
                      onChange={countryChange} // 選択状態変更時
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          <Chip
                            label={option.country_name}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          label="輸出相手国名"
                          helperText={errorCountry}
                          error={Boolean(errorCountry == "" ? false : true)}
                          // Enter無効
                          inputProps={{
                            ...params.inputProps,
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                e.stopPropagation();
                              }
                            },
                          }}
                        />
                      )}
                      filterOptions={(options) => options} // オートコンプリートの検索処理をなくす
                      getOptionLabel={(option) => option.country_name}
                      size={'medium'}
                    />
                  </RacQuarCountryContext.Provider>

                  <TextField required id="ProductCode"
                    value={ProductCode ?? ''}
                    label="品目コード"
                    onChange={e => { setProductCode(e.target.value) }}
                    disabled={(select_rac_id != -1) ? true : false}
                    helperText={errorProductCode}
                    error={Boolean(errorProductCode == "" ? false : true)}
                  />

                  <TextField required id="EnableDate"
                    value={EnableDate ?? ''}
                    label="有効日"
                    type={"date"}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={errorEnableDate}
                    error={Boolean(errorEnableDate == "" ? false : true)}
                    // disabled={(select_rac_id != -1) ? true : false}
                    onChange={e => { setEnableDate(e.target.value) }}
                  />

                  <TextField id="DisableDate"
                    value={DisableDate ?? ''}
                    label="無効日"
                    type={"date"}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={e => { setDisableDate(e.target.value) }}
                  />

                  <TextField required id="ExCode"
                    value={ExCode ?? ''}
                    label="輸出可否"
                    helperText={errorExCode}
                    error={Boolean(errorExCode == "" ? false : true)}
                    select
                    onChange={e => { setExCode(e.target.value) }}
                  >
                    {ExportLicenseList.map((option) => (
                      <MenuItem key={option.exportability_code} value={option.exportability_code}>
                        {option.exportability_code + ' : ' + option.exportability_msg}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField id="Supplement"
                    value={Supplement ?? ''}
                    label="補足文言"
                    multiline
                    rows={3}
                    onChange={e => { setSupplement(e.target.value) }}
                  />

                  <TextField id="SpecialCond"
                    value={SpecialCond ?? ''}
                    label="注釈"
                    multiline
                    rows={3}
                    onChange={e => { setSpecialCond(e.target.value) }}
                  />

                  <TextField id="Url"
                    value={Url ?? ''}
                    label="関連URL"
                    multiline
                    rows={3}
                    onChange={e => { setUrl(e.target.value) }}
                  />

                  <Stack spacing={2} direction="row">
                    <Button href="./G02010RacQuarantineList"
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>
                    <Button onClick={register} style={{ width: "200px" }}>保存</Button>
                  </Stack>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G02011RacQuarantineEdit;